var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "p",
    { staticClass: "stock-type__shipping" },
    [
      _vm._v("\n    " + _vm._s(_vm.shippingAddress.address_line_1) + "\n    "),
      _c("br"),
      _vm._v(" "),
      _vm.shippingAddress.address_line_2
        ? [
            _vm._v(
              "\n        " +
                _vm._s(_vm.shippingAddress.address_line_2) +
                "\n        "
            ),
            _c("br")
          ]
        : _vm._e(),
      _vm._v(
        "\n    " +
          _vm._s(_vm.shippingAddress.city) +
          ", " +
          _vm._s(_vm.shippingAddress.region) +
          ", " +
          _vm._s(_vm.shippingAddress.country) +
          "\n    "
      ),
      _c("br"),
      _vm._v("\n    " + _vm._s(_vm.shippingAddress.postal_code) + "\n")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }